import client from '../apolloClient';
import {CUSTOMER_QUERIES} from '../queries/customer.queries';
// Customer interface

export interface Booking {
  id: string;
  customer_id: number;
  salon_id: number;
  salon_service_id: number[];
  staff_served_id: number | null;
  staff_preference_id: number | null;
  booking_date: string;
  booking_start_time: string;
  booking_status: string;
  booking_source: string;
  service_start_timestamp: string | null;
  service_end_timestamp: string | null;
  checkin_timestamp: string | null;
  cancel_reject_reason: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  booking_expiry_time: string;
  queue_position?: number;
  salon: {
    id: string;
    salon_name: string;
    images: string[];
    address: {
      shop_or_house_number: string;
      floor_number: string;
      building_apartment_name: string;
      area: string;
      city: string;
      state: string;
      country: string;
      zip: string;
      latitude: number;
      longitude: number;
      place_id: string;
      how_to_reach: string;
      formatted_address: string;
    } | null;
  };
  customer?: {
    id: string;
    name: string;
    phone: string;
  };
  serving_staff: {
    id: string;
    name: string;
  } | null;
  preferred_staff: {
    id: string;
    name: string;
    image: string;
  } | null;
  services: Array<{
    id: number;
    name: string;
    duration: string;
    price: number;
  }>;
}
export interface GetBookingByIdResponse {
  success: boolean;
  message: string;
  booking: Booking | null;
}

export interface Service {
id: string;
service_name: string;
duration: string;
price: number;
}


export interface WebCheckinInput {
salon_id: number;
customer_name: string;
customer_mobile_number: string;
salon_service_ids: number[];
package_ids: number[];
}

export interface WebCheckinResponse {
success: boolean;
message: string;
booking: {
  id: string;
  booking_start_time: string;
  booking_status: string;
  checkin_timestamp: string;
} | null;
customer: {
  id: string;
  name: string;
  phone: string;
  signup_source: string;
} | null;
}

interface GetAllCustomersParams {
  search?: string;
  sortBy?: string;
  sortOrder?: string;
}

interface CustomerAddress {
  id: string;
  label: string;
  latitude: string;
  longitude: string;
  address: string;
  pincode: string;
}

interface Customer {
  id: string;
  name: string | null;
  phone: string;
  email: string | null;
  gender: string | null;
  image: string | null;
  created_at: string;
  updated_at: string;
  address_type: CustomerAddress[];
}

interface GetAllCustomersResponse {
  getAllCustomers: {
    customers: Customer[];
  };
}

interface AddCustomerInput {
  name: string;
  phone: string;
  email?: string;
  gender?: string;
  signup_source: string;
  signup_salon_id: string;
}

interface AddCustomerResponse {
  addCustomer: {
    customer: {
    id: string;
    name: string;
    phone: string;
    email: string | null;
    gender: string | null;
    image: string | null;
    created_at: string;
    updated_at: string;
    }
    success: boolean;
    message: string;
  };
}



export const getAllCustomers = async (params: GetAllCustomersParams = {}): Promise<GetAllCustomersResponse> => {
  try {
    console.log('Customer service: Making getAllCustomers query with params:', params);
    const { data, error } = await client.query({
      query: CUSTOMER_QUERIES.GET_ALL_CUSTOMERS,
      variables: params,
    });

    if (error) {
      console.log('Customer service: GetAllCustomers query error:', error);
      throw error;
    }
    
    console.log('Customer service: GetAllCustomers query response:', data);
    return data;
  } catch (error: any) {
    console.error('Customer service: GetAllCustomers Error:', {
      message: error.message,
      networkError: error.networkError,
      graphQLErrors: error.graphQLErrors,
      variables: params
    });
    throw error;
  }
}

export const addCustomer = async (input: AddCustomerInput): Promise<AddCustomerResponse> => {
  try {
    console.log('Customer service: Making addCustomer mutation with input:', input);
    const { data, errors } = await client.mutate({
      mutation: CUSTOMER_QUERIES.ADD_CUSTOMER,
      variables: { input },
    });

    if (errors) {
      console.error('Customer service: AddCustomer mutation errors:', errors);
      throw new Error(errors[0].message);
    }

    console.log('Customer service: AddCustomer mutation response:', data);
    return data;
  } catch (error: any) {
    console.error('Customer service: AddCustomer Error:', {
      message: error.message,
      networkError: error.networkError,
      graphQLErrors: error.graphQLErrors,
      variables: { input }
    });
    throw error;
  }
}
